import { render, staticRenderFns } from "./LawTradeFairForm.vue?vue&type=template&id=20965ff3&"
import script from "./LawTradeFairForm.vue?vue&type=script&lang=js&"
export * from "./LawTradeFairForm.vue?vue&type=script&lang=js&"
import style0 from "./LawTradeFairForm.vue?vue&type=style&index=0&id=20965ff3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports